import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';

import CheckboxContainer from './checkboxcontainer'
import React from 'react';

const CheckboxesServices = (props) => {
    return(
        <Accordion id="cbServices" className="py-1 rounded" allowZeroExpanded={true} preExpanded={["cbservs"]}>
            <AccordionItem uuid="cbservs">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <p>Filter Your Results to display only locations that offer the following:</p>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <CheckboxContainer 
                        //  Drupal data
                        featuredServices={props.featuredServices}    
                        //  state values
                        checkedItems={props.checkedItems}
                        //  handlers
                        handleCheckboxesChange={props.handleCheckboxesChange} />
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>
    )
}

export default CheckboxesServices
